import { forwardRef } from 'react';
import classNames from 'classnames';

import { useDisabled } from '@hh.ru/magritte-common-use-disabled';
import { DEFAULT_SIZE, BadgeProps } from '@hh.ru/magritte-ui-badge/types';

import styles from './badge.less';

export const Badge = forwardRef<HTMLSpanElement, BadgeProps>(
    ({ children, size = DEFAULT_SIZE, style = 'attention', 'data-qa': dataQA = 'badge' }, ref) => {
        const disabled = useDisabled();
        return (
            <span
                className={classNames(styles.badge, {
                    [styles[`badge_size-${size}`]]: size,
                    [styles[`badge_${style}`]]: style,
                    [styles.badge_disabled]: !!disabled,
                })}
                data-qa={dataQA}
                ref={ref}
            >
                {size !== 'extra-small' && children?.slice(0, 10)}
            </span>
        );
    }
);

Badge.displayName = 'Badge';
